import { Box } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from 'next/link';
import { useRouter } from 'next/router';

const CMCCloudBreadcrumbs = ({ items = [], sx, sidebarData }) => {
  const router = useRouter();
  const isProductPage = router.asPath.includes('document');
  return (
    <Box>
      <Breadcrumbs
        sx={{
          px: 4,
          color: '#A6A7AB',
          ...sx,
        }}
        separator="/"
        aria-label="breadcrumb"
      >
        {items.map((item, index) => {
          let href = item?.href || '';
          if (isProductPage && index === 2) {
            const sidebarItem = sidebarData.find((sbItem) => sbItem.attributes.name === item.label);
            if (sidebarItem) {
              href = `${item.href}/${sidebarItem?.attributes.document_pages.data[0].attributes.slug}`;
            }
          }
          return (
            <Link
              key={index}
              href={href}
              style={{
                fontFamily: 'SVN-Gotham',
                fontSize: 14,
                color: index === items.length - 1 ? '#14A8E4' : '#5E5E5E',
                fontWeight: 500,
                textTransform: 'capitalize',
              }}
            >
              {item?.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default CMCCloudBreadcrumbs;
